import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable, Signal, signal } from '@angular/core';
import { environment } from '../../../environments/environment';
import { catchError, finalize, firstValueFrom, Observable, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ApiService {

    private jsonOptions = {
        headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Accept': 'application/json, text/plain, */*',
        }),
    };

    constructor(private http: HttpClient) { }

    private buildUrl(path: string): string {
        if (!path) return environment.hostApiURL;
        if (/^https?:\/\//i.test(path)) return path;
        const base = (environment.hostApiURL || '').replace(/\/+$/, '');
        const rel = path.replace(/^\/+/, '');
        return `${base}/${rel}`;
    }

    private handleServerError(err: HttpErrorResponse) {

        if (!err.ok) {
            let errdescription = err.message;

            if (err.status == 404) {
                if (err.error && err.error.title)
                    errdescription = err.error.title;
            }
        }

        return throwError(() => err);
    }


    get(path: string): Observable<any> {
       
        // let test=  `${environment.hostApiURL}`;
        const httpOptions = {
            headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json, text/plain, */*'

            }),
        };
        const url = this.buildUrl(path);
        return this.http
            .get(url, httpOptions)
            .pipe(
                catchError((err: HttpErrorResponse) => {
                    return this.handleServerError(err);
                }),
                finalize(() => {
                })
            );
    }

    get_all(path: string, httpOptions: any): Observable<any> {

        return this.http
            .get(`${path}`, httpOptions)
            .pipe(
                catchError((err: HttpErrorResponse) => {
                    return this.handleServerError(err);
                }),
                finalize(() => {
                })
            );

    }

    get_mock(path: string): Observable<any> {

        const httpOptions = {};

        return this.http
            .get(`assets/data/${path}`, httpOptions)
            .pipe(
                catchError((err: HttpErrorResponse) => {
                    return this.handleServerError(err)
                }),
                finalize(() => {
                })
            );
    }

    get_excel(path: string): Observable<any> {

        const url = this.buildUrl(path);
        return this.http
            .get(url, { responseType: 'blob' })
            .pipe(
                catchError((err: HttpErrorResponse) => {
                    return this.handleServerError(err);
                }),
                finalize(() => {
                })
            );
    }

    post(path: string, body: object = {}): Observable<any> {

        const url = this.buildUrl(path);
        return this.http
            .post(
                url,
                JSON.stringify(body),
                this.jsonOptions
            )
            .pipe(
                catchError((err: HttpErrorResponse) => {
                    return this.handleServerError(err);
                }),
                finalize(() => {
                })
            );
    }

    put(path: string, body: any = {}): Observable<any> {

        const url = this.buildUrl(path);
        return this.http
            .put(url, JSON.stringify(body), this.jsonOptions)
            .pipe(
                catchError((err: HttpErrorResponse) => {
                    return this.handleServerError(err);
                }),
                finalize(() => {
                })
            );
    }

    delete(path: string, body: any = {}): Observable<any> {

        const url = this.buildUrl(path);
        return this.http
            .delete(url)
            .pipe(
                catchError((err: HttpErrorResponse) => {
                    return this.handleServerError(err);
                }),
                finalize(() => {
                })
            );
    }

    async get_sync<T>(path: string): Promise<T> {
        //--------------------------------------------------------------------------
        //CALL: const resultado = await this.apiService.get_sync<CLASS_TYPE>(`api/modelFiles`); 
        //--------------------------------------------------------------------------

        try {
            const response = await firstValueFrom(this.http.get<T>(path));
            return response;
        } catch (error) {
            console.error('Error during synchronous HTTP request:', error);
            throw error;
        }
    }

    async get_mock_sync<T>(path: string): Promise<T> {
        //--------------------------------------------------------------------------
        //CALL: const resultado = await this.apiService.get_mock_sync<CLASS_TYPE>(`modelFiles1.json`); //`../../assets/data/modelFiles1.json`
        //--------------------------------------------------------------------------

        const httpOptions = {};

        try {
            const response = await firstValueFrom(this.http.get<T>(`assets/data/${path}`));
            return response;
        } catch (error) {
            console.error('Error during synchronous HTTP request:', error);
            throw error;
        }
    }


}

